import { Entity } from '../entity.js';
import { getAbilityByChampSlot } from '../abilities/abilityCatalog.js';
import {
  createChargeState,
  tryConsumeCharge
} from '../abilities/abilityCharges.js';

export function createAshe(id = 'player-ashe', team = 'blue', x = 300, y = 1300) {
  const ashe = new Entity({
    id,
    type: 'champion',
    team,
    x,
    y,
    maxHp: 560,
    maxMp: 280,
    ad: 62,
    ap: 0,
    armor: 30,
    mr: 30,
    ms: 325,
    attackRange: 600,
    attackSpeed: 0.658,
    critChance: 0,
    name: 'Ashe',
    radius: 20
  });
  ashe.hawkshotCharges = createChargeState({ maxCharges: 2, rechargeSec: 90 });
  return ashe;
}

/** @returns {boolean} */
export function castAsheQ(caster) {
  if (typeof caster.activateQ === 'function') {
    return caster.activateQ();
  }
  return false;
}

export function castAsheW(caster, targetX, targetY, projectiles, gameTime) {
  const spec = getAbilityByChampSlot('ashe', 'W');
  const angle = Math.atan2(targetY - caster.y, targetX - caster.x);
  const arrowCount = spec.projectilesCount;
  const spread = spec.coneAngleRad;
  const speed = spec.travelSpeed;
  const range = spec.range;
  const startAngle = angle - spread / 2;

  for (let i = 0; i < arrowCount; i++) {
    const currentAngle = startAngle + (spread / (arrowCount - 1)) * i;
    projectiles.push({
      id: `volley-${caster.id}-${gameTime}-${i}`,
      casterId: caster.id,
      team: caster.team,
      x: caster.x,
      y: caster.y,
      vx: Math.cos(currentAngle) * speed,
      vy: Math.sin(currentAngle) * speed,
      range,
      traveled: 0,
      damage: 35 + caster.ad * 1.0,
      damageType: 'physical',
      slowValue: 0.3,
      slowDuration: 2.0,
      radius: spec.radius
    });
  }
}

/**
 * Hawkshot — 2 charges / 90s recharge / 5s static CD (FID-ABL-06).
 * @returns {boolean}
 */
export function castAsheE(caster, targetX, targetY, projectiles, gameTime) {
  if (!caster || caster.isDead || caster.isStunned) return false;
  if (!caster.hawkshotCharges) {
    caster.hawkshotCharges = createChargeState({ maxCharges: 2, rechargeSec: 90 });
  }
  const spec = getAbilityByChampSlot('ashe', 'E');
  const staticCd = spec?.cooldown ?? 5;
  if (!tryConsumeCharge(caster.hawkshotCharges, { staticCooldownSec: staticCd })) {
    return false;
  }
  caster.eCooldown = staticCd;
  caster.facingAngle = Math.atan2(targetX - caster.x, targetY - caster.y);
  projectiles.push({
    id: `hawkshot-${caster.id}-${gameTime}`,
    casterId: caster.id,
    team: caster.team,
    x: caster.x,
    y: caster.y,
    targetX,
    targetY,
    speed: spec.travelSpeed || 2400,
    range: spec.range || 25000,
    damage: 0,
    isHawkshot: true
  });
  return true;
}

export function castAsheR(caster, targetX, targetY, projectiles, gameTime) {
  const spec = getAbilityByChampSlot('ashe', 'R');
  const angle = Math.atan2(targetY - caster.y, targetX - caster.x);
  const speed = spec.travelSpeed;
  projectiles.push({
    id: `crystal-arrow-${caster.id}-${gameTime}`,
    casterId: caster.id,
    team: caster.team,
    x: caster.x,
    y: caster.y,
    vx: Math.cos(angle) * speed,
    vy: Math.sin(angle) * speed,
    range: spec.range,
    traveled: 0,
    damage: 200 + caster.ap * 1.0,
    damageType: 'magic',
    stunDuration: 2.25,
    isUlt: true,
    radius: spec.radius
  });
}
